import React from "react";
import { TbLayoutDashboardFilled, TbPackageImport, TbPackageExport } from "react-icons/tb";
import { FaTruckArrowRight, FaSheetPlastic } from "react-icons/fa6";
import { BsCalculator } from "react-icons/bs";
import { FcSettings } from "react-icons/fc";
import SidebarSettingsDropdown from "./sidebarsettingdropdown";

export default function SidebarMenu({ navigate, location, isMobile, setIsMobileOpen }) {
  const menuItems = [
    { icon: TbLayoutDashboardFilled, label: "Dashboard", path: "/dashboard" },
    { icon: TbPackageImport, label: "In-bond", path: "/in-bond" },
    { icon: TbPackageExport, label: "Ex-bond", path: "/ex-bond" },
    { icon: FaTruckArrowRight, label: "Dispatch", path: "/dispatch" },
    { icon: BsCalculator, label: "Calculator", path: "/calculator" },
    { icon: FaSheetPlastic, label: "Duty Space", path: "/duty-space" },
    { icon: FcSettings, label: "Settings", path: "/settings-dropdown" }, // special
  ];

  const handleItemClick = (path) => {
    navigate(path);
    if (isMobile) setIsMobileOpen(false);
  };

  return (
    <nav className="flex-1 overflow-y-auto sidebar-scroll">
      <ul className="flex flex-col items-center gap-2">
        {menuItems.map(({ icon: Icon, label, path }) => {
          const isActive = location.pathname.startsWith(path);

          if (label === "Settings") {
            return (
              <li key={path}>
                <SidebarSettingsDropdown navigate={navigate} />
              </li>
            );
          }

          return (
            <li
              key={path}
              onClick={() => handleItemClick(path)}
              className={`flex flex-col items-center justify-center gap-1 p-2 rounded-md w-20 cursor-pointer transition-all ${isActive ? "bg-sidebarHover text-primary" : "text-primary"
                }`}
            >
              <Icon className={`w-5 h-5 ${isActive ? "text-primary" : "text-gray-700"}`} />
              <span className="text-table font-medium truncate text-center">
                {label}
              </span>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
